import Cookies from 'js-cookie'

// Auth tokens are no longer kept in JS cookies (access token in memory, transport
// via the backend's HttpOnly cookies). Clear stale ones from the old implementation.
export const clearLegacyAuthCookies = () => {
  Cookies.remove('client_dash_user_access_token')
  Cookies.remove('user_access_refresh_token')
}
